import React from "react";
import { Button as PrimereactBtn } from "primereact/components/button/Button";
import { ProgressSpinner } from 'primereact/components/progressspinner/ProgressSpinner';

const Button = ({ label, isLoading, ...p }) =>
  <PrimereactBtn {...p} label={isLoading ? '' : label} disabled={p.disabled || isLoading}>
    {isLoading ? <ProgressSpinner className="spinner-inline spinner-button" /> : ''}
  </PrimereactBtn>;
export default Button;
